import { render } from "./UserForm.component.vue?vue&type=template&id=ad5b4e38&scoped=true&ts=true"
import script from "./UserForm.component.vue?vue&type=script&lang=ts"
export * from "./UserForm.component.vue?vue&type=script&lang=ts"

import "./UserForm.component.vue?vue&type=style&index=0&id=ad5b4e38&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5b4e38"]])

export default __exports__